import type { SxProps, Theme } from "@mui/material/styles";

export const PAGE_CONTAINER_SX: SxProps<Theme> = {
  p: { xs: 2, sm: 3, lg: 4 },
};

/** Border + radius shell used around large tables (DataGrid). */
export const DATA_GRID_SURFACE_SX: SxProps<Theme> = {
  bgcolor: "background.paper",
  borderRadius: "6px",
  border: "1px solid",
  borderColor: "divider",
  overflow: "auto",
  maxWidth: "100%",
};

export const dataGridFooterRadiusSx: SxProps<Theme> = {
  border: 0,
  minWidth: 0,
  "& .MuiDataGrid-footerContainer": {
    borderBottomLeftRadius: "6px",
    borderBottomRightRadius: "6px",
  },
};
